import { from } from 'rxjs';
import gql from 'graphql-tag';


export const queryFabricas = gql`
  query QueryFabricas {
    datos: fabricas {
      uuid
      nombre
    }
}`;


export const queryDispositivosRaiz = gql`
  query queryDispositivosRaiz{
    datos: dispositivosRaiz{
      uuid
      nombre
    }
  } `;

export const queryDatoByDependencyFrom = gql`
    query queryDatoByDependencyFrom($uuidDep: String){
        findDatoByDependencyFrom(uuidDep: $uuidDep){
            limiteInferior
            limiteSuperior
            descripcion
            uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count
            periodo
            zonaHoraria
            entradasConnection {
              edges {
                uuid
                topic
                desde
                hasta
                node {
                  uuid
                  topic
                  entradas {
                    uuid
                    topic
                    desde
                    hasta
                  }
                }
              }
            }
            dependeToConnection {
              edges {
                uuid
                variable
                node {
                  uuid
                  descripcion
                }
              }
              
            }
            dependeFromConnection {
              edges {
                uuid
                variable
              }
            }
            tiene {
              uuid
              nombre
              __typename
            }
            es {
              uuid
              nombre
              nombre_es
              nombre_en
              unidad
              __typename
            }
            calculaConnection {
              edges { 
                uuid
                disabled
                error
                formula
                desde
                hasta
                node {
                  descripcion
                  codigo
                }
              }
            }
    }
  }
`

export const queryDatoByDependencyTo = gql`
    query queryDatoByDependencyTo($uuidDep: String){
      findDatoByDependencyTo(uuidDep: $uuidDep) {
        limiteInferior
        limiteSuperior
        descripcion
        uuid
        next
        invalidated
        stats_q1
        stats_q3
        stats_min
        stats_max
        stats_median
        stats_mean
        stats_stddev
        stats_pbottom
        stats_ptop
        stats_count
        periodo
        zonaHoraria
    
        tieneConnection {
          edges {
            node {
              uuid
              descripcion
              nombre
            }
          }
        }
    
        entradasConnection {
          edges {
            uuid
            topic
            desde
            hasta
            node {
              uuid
              topic
              entradasConnection {
                edges {
                  uuid
                  topic
                  desde
                  hasta
                }
              }
            }
          }
        }
        dependeToConnection {
          edges {
            uuid
            variable
            node {   
              limiteInferior
              limiteSuperior
              descripcion
              uuid
              next
              invalidated
              stats_q1
              stats_q3
              stats_min
              stats_max
              stats_median
              stats_mean
              stats_stddev
              stats_pbottom
              stats_ptop
              stats_count
              periodo
              zonaHoraria
    
              tieneConnection {
                edges {
                  node {
                    uuid
                    descripcion
                    nombre
                  }
                }
              }
    
              entradasConnection {
                edges {
                  uuid
                  topic
                  desde
                  hasta
                  node {
                    uuid
                    topic
                    entradasConnection {
                      edges {
                        uuid
                        topic
                        desde
                        hasta
                      }
                    }
                  }
                }
              }
    
              tiene {
                uuid
                nombre
              }
              es {
                uuid
                nombre
                nombre_es
                nombre_en
                unidad
                __typename
              }
              calculaConnection {
                edges {
                  uuid
                  disabled
                  error
                  formula
                  desde
                  hasta
                  node {
                    descripcion
                    codigo
                  }
                }
              }
            }
          }
        }
        dependeFromConnection {
          edges {
            uuid
            variable
          }
        }
        tiene {
          uuid
          nombre
          __typename
        }
        es {
          uuid
          nombre
          nombre_es
          nombre_en
          unidad
          __typename
        }
        calculaConnection {
          edges {
            uuid
            disabled
            error
            formula
            desde
            hasta
            node {
              descripcion
              codigo
            }
          }
        }
      }
  }
`

export const queryNavegacionDato = gql`
  query queryNavegacionDato($uuid:String) {
    getDato(uuid: $uuid) {
      limiteInferior
      limiteSuperior
      descripcion
      uuid
      next
      invalidated
      stats_q1
      stats_q3
      stats_min
      stats_max
      stats_median
      stats_mean
      stats_stddev
      stats_pbottom
      stats_ptop
      stats_count
      stats_last
      periodo
      zonaHoraria
      tieneConnection {
        edges {
          node {
            uuid
            descripcion
            nombre
          }
        }
      }
      entradasConnection {
        edges {
          uuid
          topic
          desde
          hasta
          node {
            uuid
            topic
            entradasConnection {
              edges {
                uuid
                topic
                desde
                hasta
              }
            }
          }
        }
      }
      dependeToConnection {
        edges {
          uuid
          variable
          formula
          node {
            limiteInferior
            limiteSuperior
            descripcion
            uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count
            periodo
            zonaHoraria
            dependeToConnection {
              edges {
                uuid
                variable
                formula
                node {
                  uuid
                }
              }
            }
            tieneConnection {
              edges {
                node {
                  uuid
                  descripcion
                  nombre
                }
              }
            }
            entradasConnection {
              edges {
                uuid
                topic
                desde
                hasta
                node {
                  uuid
                  topic
                  entradasConnection {
                    edges {
                      uuid
                      topic
                      desde
                      hasta
                    }
                  }
                }
              }
            }
  
            tiene {
              uuid
              nombre
            }
            es {
              uuid
              nombre
              nombre_es
              nombre_en
              unidad
              __typename
            }
            calculaConnection {
              edges {
                uuid
                disabled
                error
                formula
                desde
                hasta
                node {
                  uuid
                  codigo
                  descripcion
                }
              }
            }
          }
        }
      }
      dependeFromConnection {
        edges {
          uuid
          variable
          formula
          node {
            limiteInferior
            limiteSuperior
            descripcion
            uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count
            periodo
            zonaHoraria
            dependeToConnection {
              edges {
                uuid
                variable
                formula
                node {
                  uuid
                }
              }
            }
            tieneConnection {
              edges {
                node {
                  uuid
                  descripcion
                  nombre
                }
              }
            }
            entradasConnection {
              edges {
                uuid
                topic
                desde
                hasta
                node {
                  uuid
                  topic
                  entradasConnection {
                    edges {
                      uuid
                      topic
                      desde
                      hasta
                    }
                  }
                }
              }
            }
            tiene {
              uuid
              nombre
            }
            es {
              uuid
              nombre
              nombre_es
              nombre_en
              unidad
              __typename
            }
            calculaConnection {
              edges {
                uuid
                disabled
                error
                formula
                desde
                hasta
                node {
                  uuid
                  descripcion
                  codigo
                }
              }
            }
          }
        }
      }
      tiene {
        uuid
        nombre
        __typename
      }
      es {
        uuid
        nombre
        nombre_es
        nombre_en
        unidad
        __typename
      }
      calculaConnection {
        edges {
          uuid
          disabled
          error
          formula
          desde
          hasta
          node {
            uuid
            codigo
            descripcion
            
          }
        }
      }
  }
  }
  
`




export const queryNavegacionDato_back = gql`
    query queryNavegacionDato($uuid: ID) {
        getDato (uuid: $uuid){
            descripcion
            uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count 
            periodo
            zonaHoraria
        entradas{
            uuid
            desde
            hasta
            topic
            Source{
                uuid
                nombre
                topic
            }
        }
        es {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
        }
        tiene {
            uuid
            nombre
        }
        calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                codigo
            }
        }
        depende {
            to {
                uuid
                variable
                Dato {
            uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count 
            periodo
        es {
            uuid
            nombre
        }
        tiene {
            uuid
            nombre
        }
        calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                codigo
            }
        }
                    depende {
                    to {
                        uuid
                        variable
                        Dato {
            uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count 
            periodo
        es {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
        }
        tiene {
            uuid
            nombre
        }
        calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                codigo
            }
        }
                }
            }
            from {
                uuid
                variable
                Dato {
                                    uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count 
            periodo
        es {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
        }
        tiene {
            uuid
            nombre
        }
        calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                codigo
            }
        }
                }
            }
        }
                }
            }
            from {
                uuid
                variable
                Dato {
                       uuid
                       next
                       invalidated
                    stats_q1
                    stats_q3
                    stats_min
                    stats_max
                    stats_median
                    stats_mean
                    stats_stddev
                    stats_pbottom
                    stats_ptop
                    stats_count
                    periodo
        es {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
        }
        tiene {
            uuid
            nombre
        }
        calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                codigo
            }
        }
        depende {
            to {
                uuid
                variable
                Dato {
                                    uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count 
            periodo
        es {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
        }
        tiene {
            uuid
            nombre
        }
        calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                codigo
            }
        }
                }
            }
            from {
                uuid
                variable
                Dato {
                                    uuid
            next
            invalidated
            stats_q1
            stats_q3
            stats_min
            stats_max
            stats_median
            stats_mean
            stats_stddev
            stats_pbottom
            stats_ptop
            stats_count 
            periodo
        es {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
        }
        tiene {
            uuid
            nombre
        }
        calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                codigo
            }
        }
                }
            }
        }
                }
            }
        }
    }
    }`;




export const queryNavegacionDatoBuena = gql`
query queryNavegacionDatoBuena($uuid: ID) {
    Dato(uuid: $uuid) {
        uuid
        next
        invalidated
        stats_q1
        stats_q3
        stats_min
        stats_median
        stats_mean
        stats_stddev
        stats_pbottom
        stats_ptop
        stats_count
        zonaHoraria
    	calcula {
            uuid
            disabled
            error
            formula
            Funcion {
                uuid
                descripcion
                codigo
                    }
            }
        es {
            uuid
            nombre
            nombre_es
            nombre_en
            unidad
        }
        tiene {
            uuid
            nombre
        }
        depende {
            to {
                uuid
              	variable
                Dato {
                    uuid
                    next
                    invalidated
                    stats_q1
                    stats_q3
                    stats_min
                    stats_median
                    stats_mean
                    stats_stddev
                    stats_pbottom
                    stats_ptop
                    stats_count
                    calcula {
                        uuid
                        disabled
                        error
                        Funcion {
                            uuid
                            codigo
                        }
                    }
              
                    }
                }
            
            from {
                uuid
                variable
                Dato {
                    uuid
                    next
                    invalidated
                    stats_q1
                    stats_q3
                    stats_min
                    stats_median
                    stats_mean
                    stats_stddev
                    stats_pbottom
                    stats_ptop
                    stats_count
                    calcula {
                        uuid
                        disabled
                        error
                        Funcion {
                            uuid
                            codigo
                        }
                    }

                }
            }
        }
    }
}`


// Query para zonas horarias:
export const arrayZonasHorarias = gql`
query Dato {
    Dato(filter: {zonaHoraria_not: null}) {
      zonaHoraria
    }
  }`


// Query que nos trae todas las funciones que hay definidas!
export const queryFunciones_back = gql`
    query queryFunciones{
        Funcion(filter:{codigo_not: null}) {
            uuid
            codigo
                }
            }`;
export const queryFunciones = gql`
            query queryFunciones{
                findFunciones {
                    uuid
                    codigo
                        }
                    }`;

export const queryTodosDatos = gql`
query queryTodosDatos{
    Dato{
        uuid
    }
}`;

/* export const QueryTipoDato = gql`
query queryTipoDato` */

// Mutarion para actualizar valores de un dato mediante el modal
export const ActualizarDato = gql`
mutation ActualizarDato($dato: String, $stats_pbottom: number, $stats_ptop: stats_ptop) {
    updateDato(dato: $dato, stats_pbottom: $stats_pbottom, stats_ptop: $stats_ptop)}`;


// Mutation para actualizar descripcion, limite inferior y limite superior de un dato
export const updateDato = gql`
mutation ActualizarDato($dato: String, $descripcion: String, $limiteInferior: Float, $limiteSuperior: Float, $depUUID: String, $desde: Float, $hasta: Float) {
    updateDato(dato: $dato, descripcion: $descripcion, limiteInferior: $limiteInferior, limiteSuperior: $limiteSuperior) {
        descripcion
        limiteInferior
        limiteSuperior
    }

    updateCalculaDates(uuid: $depUUID, desde: $desde, hasta: $hasta) {
      uuid
      desde
      hasta
    }
}`;

// Mutation para añadir una dependencia a un dato
export const queryAddDependency = gql`
mutation queryAddDependency($datouuid: String!, $depuuid: String){
    addDependency(datouuid: $datouuid, depuuid: $depuuid){
        uuid
    } 
}`

// Mutation para cambiarle la función de cálculo al dato actual:
export const updateFuncion = gql`
mutation updateFuncion($dato: String, $codigo: String) {
    updateDato(dato: $dato, codigo: $codigo){
        periodo
    }}`;

// Mutation para borrar una dependencia de un dato:
export const queryDeleteDepedency = gql`
mutation queryDeleteDependency($duuid: String){
    deleteDependency(duuid: $duuid)}`

// Mutarion para actualizar la descripcion del dato
export const ActualizarDescripcion = gql`
mutation ActualizarDato($dato: String, $descripcion: String) {
    updateDato(dato: $dato, descripcion:$descripcion) {
        uuid
    }
}`;



export const queryDatoActual = gql`
    query queryDatoActual($uuid: ID) {
        Dato (uuid: $uuid){
                uuid
                next
                invalidated
                stats_q1
                stats_q3
                stats_min
                stats_max
                stats_median
                stats_mean
                stats_stddev
                stats_pbottom
                stats_ptop
                stats_count 
                zonaHoraria
            es {
                uuid
                nombre
                nombre_es
                nombre_en
                unidad
            }
            tiene {
                uuid
                nombre
            }
            calcula {
                uuid
                disabled
                error
                Funcion {
                    uuid
                    codigo
                }
            }
        }
    }`


// Función para recalcular el dato actual
export const recalcularDato = gql`
mutation recalcularDato($uuidDato: String) {
    recalcularDato(uuidDato: $uuidDato){
        uuid
    } 
}`;

export const cambiarVariable = gql`
mutation cambiarVariable($dependencia: String, $variable:String) {
    cambiarVariable(dependencia: $dependencia, variable: $variable) {
        uuid
      }
}`

export const actualizarFormulaDep = gql`
mutation actualizarFormulaDep($dependencia: String, $formula:String) {
  actualizarFormulaDep(dependencia: $dependencia, formula: $formula) {
        uuid
      }
}`

export const cambiarFormula = gql`
mutation cambiarFormula($calcula: String, $formula: String){
    cambiarFormula(calcula: $calcula, formula: $formula){
        uuid
       }
    }`

export const asignarFuncion = gql`
mutation asignarFuncion($dato: String, $funcion: String){
    asignarFuncion(dato: $dato, funcion: $funcion ) {
        uuid
    }
}`;

export const cambiarZonaHoraria = gql`
mutation UpdateDato($dato: String, $zonaHoraria: String){
    updateDato(dato: $dato, zonaHoraria: $zonaHoraria) {
        uuid
        zonaHoraria
    }
}`
